const messages = {
  title: "Поддръжка!",
  description:
    'В момента се извършват необходимите работи по поддръжка на сървърите.<br/><br/>Поради това в момента нямате достъп до <b>BRIDGESTONE <span class="text-danger">PLUS</span></b>.<br/><br/>Молим за вашето търпение и ви благодарим за разбирането.<br/><br/> Вашият екип на Bridgestone',
}
export default {
  messages
}
